export const blurActiveElement = () => {
  const inputElement = document.activeElement as
    | HTMLInputElement
    | HTMLButtonElement
    | undefined;
  inputElement?.blur();
};
